import React from 'react';
import { Box, Typography, Button, Stack } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import InboxIcon from '@mui/icons-material/Inbox';
import SearchOffIcon from '@mui/icons-material/SearchOff';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

interface EmptyStateProps {
  title: string;
  description?: string;
  icon?: React.ReactNode;
  action?: {
    label: string;
    onClick: () => void;
  };
  variant?: 'empty' | 'search' | 'error';
}

const iconMap = {
  empty: InboxIcon,
  search: SearchOffIcon,
  error: ErrorOutlineIcon,
};

export const EmptyState: React.FC<EmptyStateProps> = ({
  title,
  description,
  icon,
  action,
  variant = 'empty',
}) => {
  const theme = useTheme();
  const DefaultIcon = iconMap[variant];

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        py: 8,
        px: 2,
        textAlign: 'center',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: 120,
          height: 120,
          borderRadius: '50%',
          backgroundColor: theme.palette.mode === 'dark'
            ? theme.palette.grey[800]
            : theme.palette.grey[100],
          mb: 3,
        }}
      >
        {icon ? (
          icon
        ) : (
          <DefaultIcon 
            sx={{ 
              fontSize: 60, 
              color: theme.palette.text.secondary 
            }} 
          />
        )}
      </Box>
      
      <Stack spacing={1} alignItems="center" maxWidth={400}>
        <Typography variant="h6" color="text.primary" fontWeight={600}>
          {title}
        </Typography>
        
        {description && (
          <Typography variant="body2" color="text.secondary">
            {description}
          </Typography>
        )}
        
        {action && (
          <Box sx={{ mt: 3 }}>
            <Button
              variant="contained"
              onClick={action.onClick}
              size="large"
            >
              {action.label}
            </Button>
          </Box>
        )}
      </Stack>
    </Box>
  );
};